/* import __COLOCATED_TEMPLATE__ from './share-modal.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action } from '@ember/object';

////////////////////////////////////////////////////////////////////////////////////
// share-modal - component for the share design url modal dialog box              //
////////////////////////////////////////////////////////////////////////////////////

export default class ShareModal extends Component {
  tagName = '';
  @service('aditools-analytics') analytics;
  @service intl;
  @tracked copyResultClass = null;
  @tracked copyResultGlyph = null;
  @tracked copyResultMessage = null;

  ////////////////////////////////////////////////////////////////////////////////
  // Component Actions                                                          //
  ////////////////////////////////////////////////////////////////////////////////

  @action insertedSharePopup() {
    this.copyResultClass = '';
    this.copyResultGlyph = '';
    this.copyResultMessage = '';
  }

  @action copyClick() {
    navigator.clipboard.writeText(this.args.urlString).then(
      () => {
        this.copyResultClass = 'share-confirmation-ok';
        this.copyResultMessage = this.intl.t('help.share.copy');
        this.copyResultGlyph = 'circle-check';
      },
      () => {
        this.copyResultClass = 'share-confirmation-ng';
        this.copyResultMessage = this.intl.t('help.share.copyFail');
        this.copyResultGlyph = 'circle-xmark';
      },
    );
  }
}
